<div class="hero-full">
  <img src="assets/images/gorilla.jpg"
    alt="ZamaDev Landing" class="full-responsive-img">
</div>